import { PaletteOptions, PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { grey, unityGrey } from './colors';

export const greyOption = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['grey'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          50: unityGrey[50],
          100: unityGrey[100],
          200: unityGrey[200],
          300: unityGrey[300],
          400: unityGrey[400],
          500: unityGrey[500],
          600: unityGrey[600],
          700: unityGrey[700],
          800: unityGrey[800],
          900: unityGrey[900],
          950: unityGrey[950],
        }
      : // Reverse greys from darkest to lightest for Dark mode
        {
          50: unityGrey[950],
          100: unityGrey[900],
          200: unityGrey[800],
          300: unityGrey[700],
          400: unityGrey[600],
          500: unityGrey[500],
          600: unityGrey[400],
          700: unityGrey[300],
          800: unityGrey[200],
          900: unityGrey[100],
          950: unityGrey[50],
        };
  }

  return mode === 'light'
    ? {
        50: grey[50],
        100: grey[100],
        200: grey[200],
        300: grey[300],
        400: grey[400],
        500: grey[500],
        600: grey[600],
        700: grey[700],
        800: grey[800],
        900: grey[900],
        950: grey[950],
      }
    : // Reverse greys from darkest to lightest for Dark mode
      {
        50: grey[950],
        100: grey[900],
        200: grey[800],
        300: grey[700],
        400: grey[600],
        500: grey[500],
        600: grey[400],
        700: grey[300],
        800: grey[200],
        900: grey[100],
        950: grey[50],
      };
};
